import { Particle } from "../Particle";

export class Empty extends Particle {
    static color = 0x000000; // 背景色

    constructor() {
        super({
            name: "Empty",
            color: Empty.color,
            empty: true,
            temperature: 20,
            minTemp: -273,
            maxTemp: 10000
        });
    }
}
